export const GET_CURRENCIES_START = 'GET_CURRENCIES_START';
export const GET_CURRENCIES_SUCCESS = 'GET_CURRENCIES_SUCCESS';
export const GET_CURRENCIES_ERROR = 'GET_CURRENCIES_ERROR';
export const GET_CURRENCIES_END = 'GET_CURRENCIES_END';
export const GET_CURRENCIES_CLEAR = 'GET_CURRENCIES_CLEAR';
